import {KeyCloackUserDTO} from "./KeyCloackUserDTO";

export abstract class BaseDTO {
    public createdBy?: string;
    public createdDate?: Date;
    public creater?: KeyCloackUserDTO;
    public updatedBy?: string;
    public updatedDate?: Date;
    public updater?: KeyCloackUserDTO;
    public version?: number;
    public controller?: KeyCloackUserDTO;
    public controlDate?: Date;

    constructor() {
    }

    // public abstract getPrimaryKey(): number;

    bindData(obj: any, level?:any): void {
        if (obj == null) {
            return;
        }
        this.createdBy = obj.createdBy;
        this.createdDate = obj.createdDate;
        this.creater = obj.creater;
        this.updatedBy = obj.updatedBy;
        this.updatedDate = obj.updatedDate;
        this.updater = obj.updater;
        this.version = obj.rowVersion;
        this.controlDate = obj.controlDate;
        this.controller = obj.controller;
    }

    equals(obj:any): boolean {
        return obj.hasOwnProperty("rowVersion") && obj["rowVersion"] === this.version;
    }

    toCreatorInformationString(localize:any) {
        let text = [];
        if (this.creater) {
            if (this.creater.firstName) {
                text.push(localize.getLocalizationValue('CreatedBy') + ": " + this.creater.firstName + " " + this.creater.lastName);
            }
            if (this.createdDate) {
                let newDate = new Date(this.createdDate);
                text.push(localize.getLocalizationValue('CreatedDate') + ": " + newDate.toLocaleDateString('Tr-tr'));
            }
        }
        if (this.updater) {
            if (this.updater.firstName) {
                text.push(localize.getLocalizationValue('UpdatedBy') + ": " + this.updater.firstName + " " + this.updater.lastName);
            }
            if (this.updatedDate) {
                let newDate = new Date(this.updatedDate);
                text.push(localize.getLocalizationValue('UpdatedDate') + ": " + newDate.toLocaleDateString('Tr-tr'));
            }
        }
        if (this.controller) {
            if (this.controller.firstName) {
                text.push(localize.getLocalizationValue('Controller') + ": " + this.controller.firstName + " " + this.controller.lastName);
            }
            if (this.controlDate) {
                let newDate = new Date(this.controlDate);
                text.push(localize.getLocalizationValue('ControlledDate') + ": " + newDate.toLocaleDateString('Tr-tr'));
            }
        }

        return text.join('\n');
    }
}
